// ============================================
// OpenPortfolio - Icon Component
// Lucide React Icon Wrapper
// WCAG 2.5 AAA Compliant
// ============================================

import React from 'react';
import {
  Home,
  User,
  Folder,
  Heart,
  Mail,
  Github,
  Twitter,
  Linkedin,
  ExternalLink,
  ChevronDown,
  ChevronUp,
  Menu,
  X,
  Code2,
  Terminal,
  Database,
  Server,
  Cloud,
  Brain,
  Bot,
  Sparkles,
  Settings,
  Package,
  MapPin,
  Globe,
  Compass,
  Navigation,
  Link2,
  Link2Off,
  Copy,
  Share2,
  Download,
  Upload,
  RefreshCw,
  Edit,
  Trash2,
  Plus,
  Minus,
  Send,
  Users,
  Award,
  Briefcase,
  GraduationCap,
  Cpu,
  BarChart3,
  TrendingUp,
  Activity,
  Zap,
  Rocket,
  Target,
  Flag,
  Tag,
  Tags,
  Hash,
  AtSign,
  Phone,
  Volume,
  Volume2,
  VolumeX,
  Mic,
  MicOff,
  Headphones,
  Speaker,
  Monitor,
  Aperture,
  Shield,
  ShieldCheck,
  ShieldAlert,
  ShieldX,
  Lock,
  Unlock,
  Key,
  Eye,
  EyeOff,
  File,
  FileText,
  FilePlus,
  FileImage,
  Clipboard,
  ClipboardList,
  ClipboardCheck,
  List,
  ListOrdered,
  ListChecks,
  AlignLeft,
  AlignCenter,
  AlignRight,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Highlighter,
  Type,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Quote,
  Code,
  Variable,
  Braces,
  Parentheses,
  Brackets,
  CornerDownLeft,
  Maximize,
  Minimize,
  ZoomIn,
  ZoomOut,
  Move,
  GripVertical,
  Grip,
  Circle,
  CircleDot,
  Hexagon,
  Square,
  Crosshair,
  MousePointer,
  MousePointer2,
  Hand,
  Layout,
  LayoutDashboard,
  LayoutGrid,
  LayoutTemplate,
  PanelLeft,
  Sidebar,
  SidebarOpen,
  SidebarClose,
  ArrowUpRight,
  ArrowLeft,
  ArrowRight,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Clock,
  Calendar,
  HeartHandshake,
  Coffee,
  Loader2,
  Star,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const iconMap: Record<string, LucideIcon> = {
  home: Home,
  user: User,
  folder: Folder,
  heart: Heart,
  mail: Mail,
  github: Github,
  twitter: Twitter,
  linkedin: Linkedin,
  external: ExternalLink,
  'external-link': ExternalLink,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  menu: Menu,
  x: X,
  'arrow-up-right': ArrowUpRight,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  star: Star,
  fork: Star,
  code: Code,
  'code-2': Code2,
  terminal: Terminal,
  database: Database,
  server: Server,
  cloud: Cloud,
  cpu: Cpu,
  sparkles: Sparkles,
  zap: Zap,
  brain: Brain,
  bot: Bot,
  settings: Settings,
  layers: Package,
  palette: Settings,
  puzzle: Package,
  package: Package,
  'help-circle': HelpCircle,
  info: Info,
  'alert-triangle': AlertTriangle,
  check: CheckCircle,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  clock: Clock,
  calendar: Calendar,
  'map-pin': MapPin,
  map: MapPin,
  globe: Globe,
  compass: Compass,
  navigation: Navigation,
  link: Link2,
  'link-2': Link2,
  'link-off': Link2Off,
  copy: Copy,
  share: Share2,
  download: Download,
  upload: Upload,
  refresh: RefreshCw,
  edit: Edit,
  trash: Trash2,
  plus: Plus,
  minus: Minus,
  send: Send,
  briefcase: Briefcase,
  graduation: GraduationCap,
  users: Users,
  award: Award,
  'bar-chart': BarChart3,
  'trending-up': TrendingUp,
  activity: Activity,
  rocket: Rocket,
  target: Target,
  flag: Flag,
  bookmark: Tag,
  tag: Tag,
  tags: Tags,
  hash: Hash,
  at: AtSign,
  phone: Phone,
  volume: Volume,
  'volume-2': Volume2,
  'volume-x': VolumeX,
  mic: Mic,
  'mic-off': MicOff,
  headphones: Headphones,
  speaker: Speaker,
  monitor: Monitor,
  aperture: Aperture,
  shield: Shield,
  'shield-check': ShieldCheck,
  'shield-alert': ShieldAlert,
  'shield-x': ShieldX,
  lock: Lock,
  unlock: Unlock,
  key: Key,
  eye: Eye,
  'eye-off': EyeOff,
  file: File,
  'file-text': FileText,
  'file-plus': FilePlus,
  'file-image': FileImage,
  clipboard: Clipboard,
  'clipboard-list': ClipboardList,
  'clipboard-check': ClipboardCheck,
  list: List,
  'list-ordered': ListOrdered,
  'list-checks': ListChecks,
  'align-left': AlignLeft,
  'align-center': AlignCenter,
  'align-right': AlignRight,
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strikethrough: Strikethrough,
  highlighter: Highlighter,
  type: Type,
  heading: Heading,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  quote: Quote,
  variable: Variable,
  braces: Braces,
  parentheses: Parentheses,
  brackets: Brackets,
  'corner-down-left': CornerDownLeft,
  layout: Layout,
  'layout-dashboard': LayoutDashboard,
  'layout-grid': LayoutGrid,
  'layout-template': LayoutTemplate,
  'panel-left': PanelLeft,
  sidebar: Sidebar,
  'sidebar-open': SidebarOpen,
  'sidebar-close': SidebarClose,
  maximize: Maximize,
  minimize: Minimize,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  move: Move,
  'grip-vertical': GripVertical,
  grip: Grip,
  circle: Circle,
  'circle-dot': CircleDot,
  hexagon: Hexagon,
  square: Square,
  crosshair: Crosshair,
  'mouse-pointer': MousePointer,
  'mouse-pointer-2': MousePointer2,
  hand: Hand,
  donate: HeartHandshake,
  coffee: Coffee,
  loader: Loader2,
};

export type { LucideIcon as IconProps };

const Icon = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGSVGElement> & {
  name: string;
  size?: number | string;
  strokeWidth?: number;
  className?: string;
}>(({ name, size = 24, strokeWidth = 2, className, ...props }, ref) => {
  const IconComponent = iconMap[name] || iconMap['x'];

  return (
    <IconComponent
      ref={ref}
      size={size}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
      aria-hidden="true"
      {...props}
    />
  );
});

Icon.displayName = 'Icon';

export { Icon };